import DynamicSunLogo from './DynamicSunLogo';

const Logo = ({ collapsed, onToggle }) => {
    return (
        <div className="logo" onClick={onToggle} style={{ cursor: 'pointer' }}>
            <div className="logo-icon">
                <DynamicSunLogo size={56} tooltipSuffix={collapsed ? 'Click para expandir' : 'Click para colapsar'} />
            </div>
        </div>
    );
};
export default Logo;